import { render } from "./ProductsLiveFuture.vue?vue&type=template&id=7dad518f&scoped=true"
import script from "./ProductsLiveFuture.vue?vue&type=script&lang=js"
export * from "./ProductsLiveFuture.vue?vue&type=script&lang=js"

import "./ProductsLiveFuture.vue?vue&type=style&index=0&id=7dad518f&lang=scss&scoped=true"
import "./ProductsLiveFuture.vue?vue&type=style&index=1&id=7dad518f&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dad518f"]])

export default __exports__